var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50085 8.74014L1.03195 6.95114C0.857768 6.73857 0.821516 6.44474 0.938913 6.19626C1.05631 5.94779 1.3063 5.7892 1.58108 5.78881L4.51956 5.78885C4.79434 5.7892 5.04433 5.94779 5.16173 6.19626C5.27913 6.44474 5.24287 6.73857 5.06869 6.9511L3.59979 8.74014C3.46468 8.90477 3.26293 9.0002 3.04993 9.0002C2.83693 9.0002 2.63518 8.90477 2.50007 8.74014H2.50085ZM1.5448 3.89667C1.26833 3.89676 1.01687 3.73655 0.900033 3.48596C0.783157 3.23536 0.822144 2.93974 0.999933 2.728L2.49939 0.941082C2.63455 0.780009 2.834 0.687012 3.04426 0.687012C3.25453 0.687012 3.45398 0.780009 3.58913 0.941082L5.08933 2.72796C5.26712 2.93974 5.30611 3.23536 5.18923 3.48596C5.0724 3.73655 4.82093 3.89676 4.54446 3.89672L1.5448 3.89667Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownArrow);
export default __webpack_public_path__ + "static/media/up_down_arrow.4809299fcb403b9c08ee5c4efd02da0a.svg";
export { ForwardRef as ReactComponent };